import React, { useCallback, useEffect, useState } from 'react'
import { AccountAside, ClientAside } from './taskAside'
import { ChatBox } from 'components/RemoteChat'
import { useDispatch, useSelector } from 'react-redux'
import { changeActiveTaskAction } from 'store/taskManager/actions'
import LoaderAside from './taskAside/LoaderAside'
import { useHasUserTag, Grid } from '@centra/centra-ui'

import styles from './TaskChat.module.scss'

interface ISingleTask {
  onClose: () => void
  loading: boolean
  isTaskModalCreating?: boolean
}

const SingleTask = (props: ISingleTask) => {
  const { onClose, loading } = props
  const dispatch = useDispatch()
  const [name, setName] = useState('')
  const [isShowExtraMessages, setShowExtraMessages] = useState(false)
  const { task, taskLoading } = useSelector(({ taskManager }) => ({
    task: taskManager.task,
    taskLoading: taskManager.taskLoading,
  }))

  const isAccountManager = useHasUserTag(['role.account-manager'])

  const refetchTask = useCallback(() => {
    if (task?.id) {
      dispatch(changeActiveTaskAction({ id: task.id }))
    }
  }, [task?.id])

  useEffect(() => {
    return () => {
      dispatch(changeActiveTaskAction({ id: 0 }))
    }
  }, [])

  useEffect(() => {
    if (task) setName(task.name)
  }, [task])

  const onChangeShowExtraMessages = () => {
    setShowExtraMessages(!isShowExtraMessages)
  }

  return (
    <Grid className={styles.root}>
      {loading ? (
        <LoaderAside />
      ) : (
        <>
          {isAccountManager ? (
            <AccountAside
              name={name}
              isShowExtraMessages={isShowExtraMessages}
              onClose={onClose}
              onChangeShowExtraMessages={onChangeShowExtraMessages}
            />
          ) : (
            <ClientAside
              isShowExtraMessages={isShowExtraMessages}
              onClose={onClose}
              onChangeShowExtraMessages={onChangeShowExtraMessages}
            />
          )}
        </>
      )}

      <ChatBox
        id="SingleTaskChatBox"
        task={task}
        taskLoading={taskLoading}
        onClose={onClose}
        name={name}
        onChangeName={setName}
        isShowExtraMessages={isShowExtraMessages}
        refetchTask={refetchTask}
      />
    </Grid>
  )
}

export default SingleTask
